import { ChangeDetectionStrategy, Component, OnDestroy } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";

import { TextConstants } from "@shared/constants";
import { RulesetResourceTypeEnum } from "@shared/enums";
import { IConditionForm } from "@shared/interfaces";
import { CommonUtils, LocalizationUtils } from "@shared/utils";

import { RulesetBaseClass } from "../ruleset-base.class";

@Component({
  standalone: false,
  selector: "app-ruleset-details",
  templateUrl: "./ruleset-details.component.html",
  styleUrl: "./ruleset-details.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RulesetDetailsComponent extends RulesetBaseClass implements OnDestroy {
  public readonly mainInformationText = TextConstants.MAIN_INFORMATION;

  public readonly recordDetailsText = TextConstants.RECORD_DETAILS;

  public conditionFormGroup: FormGroup<IConditionForm>;

  public expectationFormGroup: FormArray<FormGroup>;

  public readonly translations: any = {
    title: $localize`:@@rulesets.rulesetdetails:Ruleset details`,
    titleBackText: $localize`:@@shared.backtorulesets:Back to Rulesets`,
    editLabel: TextConstants.EDIT,
    archived: TextConstants.ARCHIVED,
  };

  public resourceTypePlural: string;

  protected override async loadData(rulesetId: string): Promise<boolean> {
    this.isLoading.set(true);
    try {
      const ruleset = await this.rulesetsService.get(rulesetId);

      this.element.set(ruleset);
      this.resourceType = ruleset.resourceType;
      this.resourceTypePlural = LocalizationUtils.getEntityType(
        CommonUtils.enumToText(
          ruleset.resourceType === RulesetResourceTypeEnum.CONNECTION
            ? "organisation"
            : ruleset.resourceType,
        ),
        true,
      );

      this.propertyOptions = this.rulesetsBuilderService.getPropertyOptions(ruleset.resourceType);

      const { condition, expectations } = this.element();

      if (this.rulesetsBuilderService.isConditionPresent(condition)) {
        this.conditionFormGroup = this.rulesetsBuilderService.getConditionForm(condition, true);
      }

      this.expectationFormGroup = this.getExpectationsForm(expectations, true);

      await Promise.all([
        this.setLocationTypeOptions(),
        this.setLocationOptions(),
        this.setDocumentTypeOptions(),
      ]);
      this.isLoading.set(false);

      return true;
    } catch (error) {
      this.notificationService.showError(error);

      return false;
    }
  }

  public onEdit = async (): Promise<void> => {
    await this.navigateToEditRuleset(this.element().resourceType, this.element().id);
  };

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
